/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/partner.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Partner
 */
export interface Partner {
    /**
     * @generated from protobuf field: optional string impact_radius_irad = 1;
     */
    impact_radius_irad?: string;
    /**
     * @generated from protobuf field: optional string impact_radius_irmp = 2;
     */
    impact_radius_irmp?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Partner$Type extends MessageType<Partner> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Partner", [
            { no: 1, name: "impact_radius_irad", kind: "scalar", localName: "impact_radius_irad", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???" } },
            { no: 2, name: "impact_radius_irmp", kind: "scalar", localName: "impact_radius_irmp", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???" } }
        ]);
    }
    create(value?: PartialMessage<Partner>): Partner {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Partner>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Partner): Partner {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string impact_radius_irad */ 1:
                    message.impact_radius_irad = reader.string();
                    break;
                case /* optional string impact_radius_irmp */ 2:
                    message.impact_radius_irmp = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Partner, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string impact_radius_irad = 1; */
        if (message.impact_radius_irad !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.impact_radius_irad);
        /* optional string impact_radius_irmp = 2; */
        if (message.impact_radius_irmp !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.impact_radius_irmp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Partner
 */
export const Partner = new Partner$Type();
